import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { PackageService } from '../../common/package.service';
import { ActivityService } from '../../common/activity.service';
import { ActivityLimitFormComponent } from '../activity-limit-form/activity-limit-form.component';
import { MdDialog } from '@angular/material';

@Component({
  selector: 'package-activity-limits',
  templateUrl: './package-activity-limits.component.html',
  styleUrls: ['./package-activity-limits.component.css', '../../app.component.css'],
  providers: [ActivityService , PackageService],
})

export class PackageActivityLimitsComponent implements OnInit {

  eventId: any;
  packageId: any;
  activityId: any;
  activityLimits: any;
  activityLimitId: any;
  spinner: boolean = false;

  constructor(private formBuilder: FormBuilder, private activatedRoute: ActivatedRoute, private packageService: PackageService, public dialog: MdDialog, private activityService: ActivityService){
  }

  ngOnInit() {
  }

  getActivityLimits(){
   this.spinner = true;
   this.packageService.getActivityLimits(this.packageId).subscribe(
    response => {
     this.spinner = false;
     this.activityLimits = response;
    },
    error => {
     this.spinner = false;
    }
   );
  }

  activityLimitFormDialog(params) {
    if(params && params.id)
    this.activityLimitId = params.id;
    else
    this.activityLimitId = 0;
    let dialogRef = this.dialog.open(ActivityLimitFormComponent);
    dialogRef.componentInstance.eventId = this.activityLimitId;
    this.activityService.getActivities(this.eventId).subscribe(response => {
     dialogRef.componentInstance.activities = response;
    });
    dialogRef.componentInstance.packageId = this.packageId;
    dialogRef.componentInstance.activityLimitId = this.activityLimitId;
    if(this.activityLimitId)
    {
     this.packageService.findActivityLimit(this.activityLimitId).subscribe(response => {
      dialogRef.componentInstance.activityLimit = response[0];
     });
    }
    else
    dialogRef.componentInstance.activityLimit = dialogRef.componentInstance.activityLimitForm.value;
    dialogRef.componentInstance.onSave.subscribe(() => {
     this.getActivityLimits();
     dialogRef.close();
    });
  }

  deleteActivityLimit(params){
   if(confirm('Are you sure?'))
   {
    this.spinner = true;
    this.packageService.deleteActivityLimit(params).subscribe(
     response => {
      this.spinner = false;
      if(response.status)
      this.getActivityLimits();
     },
     error => {
      this.spinner = false;
     }
    );
   }
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/package-activity-limits/package-activity-limits.component.ts